import React from 'react'

const ErrorPage = () => {
  return <div>Error PAge comp comes here</div>
}

export default ErrorPage
